import styled from 'styled-components';

import ArrowDownIcon from '../../../../Icons/ArrowDownIcon';

export const PricingBlockWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:100%;
`,
);

export const PricingBlockInnerWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:100%;
  background-color: ${props.theme.colors.white.base};
  border-radius: 1rem;
  box-shadow: 0 4px 8px 0 rgba(138, 107, 118, 0.08);
`,
);

export const PricingTxtWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l20};;
  justify-content:space-between;
  align-items: center;
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lightdd};

`,
);


export const PricingTxtSpan = styled.span(
  props => `
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.black};
    font-size:${props.theme.font.large.font18};
`,
);

export const RoomChargesOuterWrapDiv = styled.div(
  props => `

  display:${props.display || 'flex'};
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  padding-left:${props.theme.spacing.large.l12};
  padding-right:${props.theme.spacing.large.l12};
  padding-top:${props.theme.spacing.base};
  padding-bottom:${props.theme.spacing.base};
  display: ${props.display};

`,
);

export const RoomChargesWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  // border: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
  // border-radius:${props.theme.misc.borderRadius.large}
  justify-content: space-between;
  padding-bottom:${props.theme.spacing.base};

`,
);

export const PricingInnerWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;

`,
);

export const PricingNewWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  padding-top:${props.theme.spacing.small.s5};
  width:100%;

`,
);

export const AmountTxtSpan = styled.span(
  props => `


    font-weight: bold;
    font-size:${props.theme.font.large.font16};
    padding-right:${props.theme.spacing.base};

`,
);

export const TotalAmountTxtSpan = styled.span(
  props => `
    font-weight: ${props.theme.font.fontWeight.black};
    font-size:${props.theme.font.large.font18};
  `
)

export const BreakUpPriceWrapSpan = styled.span(
  props => `
    // font-size:${props.theme.font.large.font14};
  `,
);

export const ConviFeeWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  padding-top:${props.theme.spacing.small.s5};
  padding-bottom:${props.theme.spacing.small.s5};
  padding-right:${props.theme.spacing.base};
  padding-left:${props.theme.spacing.base};
  width:100%;
  font-weight: ${props.fw};
  font-size: ${`${props.fs}px`};
  color: ${props.color};

`,
);

export const ConvifeeTxtSpan = styled.span(
  props => `
    // font-size:${props.theme.font.large.font14};
`,
);

export const DiscountWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
  border-radius:${props.theme.misc.borderRadius.large}
  justify-content: space-between;

`,
);

export const DiscountWrapInnerDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  justify-content: space-between;
  padding:${props.theme.spacing.base};
`,
);

export const DiscountTxtSpan = styled.span(
  props => `
    font-size:${props.theme.font.large.font14};
    font-weight:bold;
  ;
`,
);

export const TotalAmountInfoTxtSpan = styled.span(
  props => `
  font-size:${props.theme.font.large.font16};
  font-weight:${props.theme.font.fontWeight.black};
  `
)

export const CircularDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  width:2.6rem;
  height:2.6rem;
`,
);

export const ArrowDownNewWrap = styled(ArrowDownIcon)(
  props => `
      width:1rem;
      height:1rem;
      fill: ${props.theme.colors.blue.base};
      margin-top:${props.theme.spacing.small.s8};
      margin-left:${props.theme.spacing.small.s8};
      position:absolute;
      transform: ${props.transformstyle};
      transition: transform 0.5s;
  `,
);

export const RoomChargesTotalOuterWrapDiv = styled.div(
  props => `
    width:100%;
    display: flex;
    background-color: ${props.theme.colors.yellow.bgLight};
    padding: ${props.theme.spacing.large.l12} ${props.theme.spacing.large.l20};
  `
);

export const RoomTotalPriceWrap = styled.div(
  props => `
    display: flex;
    width: 100%;
    flex-direction: column;
  `
);


export const RoomTotalPriceInnerWrap = styled.div(
  props => `
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  `
);
